import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DictionaryKey, DictionaryShortEntry, HxDictionaryService, HxUiLabelPipe } from 'hx-services';
import { NgOptionComponent, NgSelectComponent } from '@ng-select/ng-select';
import { NgFor } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
    selector: 'hx-dictionary-select',
    templateUrl: './dictionary-select.component.html',
    styleUrls: ['./dictionary-select.component.css'],
    providers: [{
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => HxDictionarySelectComponent),
      multi: true
    }],
  imports: [NgSelectComponent, FormsModule, NgFor, NgOptionComponent, TranslocoPipe, HxUiLabelPipe]
})
export class HxDictionarySelectComponent implements OnInit, ControlValueAccessor {
  @Input({required: true}) dictionaryKey!: DictionaryKey;
  @Input() autoSelect = false;
  @Input() multiple = false;
  @Input() disabled = false;
  @Output() selectChange = new EventEmitter<DictionaryShortEntry | DictionaryShortEntry[] | undefined>();

  options: DictionaryShortEntry[] = [];
  selected: string | string[] | undefined;

  constructor(
    private dictionaryService: HxDictionaryService,
  ) {}

  async ngOnInit() {
    this.options = await this.dictionaryService.getEntries({key: this.dictionaryKey});
    if (this.autoSelect && (this.options ?? []).length === 1) {
      this.selected = this.options[0].code;
      this.onModelChanged(this.selected);
    }
  }

  onModelChanged(val: any) {
    this.onChange(val);
    if (!this.multiple) {
      if (this.selected) {
        this.selectChange.emit(this.options.find(p => p.code === this.selected));
      } else {
        this.selectChange.emit();
      }
    } else {
      if (Array.isArray(this.selected)) {
        const codes: string[] = this.selected;
        this.selectChange.emit(this.options.filter(p => codes.includes(p.code)));
      } else {
        this.selectChange.emit([]);
      }
    }
  }

  onChange(val: any) {
    // console.log('onChange called', val);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  writeValue(obj?: string | string[]): void {
    this.selected = obj;
  }
}
